module.exports = __webpack_public_path__ + "img/plugin_quickbooks.ddfc5dc1.svg";